import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import H5 from './H5';

export default function Z2() {
    const { useLang, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [isEnter, setIsEnter] = useState('enter');

    const imgSpec: any = {
        jp: '_jp',
        cn: '_cn',
    };

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.d2x-Z2 .t-m-b', { scale: 3, opacity: 0 }, { scale: 1, opacity: 1 }, 4],
                ['.d2x-Z2 .t-l-t', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-m-t-l', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-m-t-r', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-r', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .last-box', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .b-m .b-m-r', { opacity: 0 }, { opacity: 1 }, 1],
                // ['.d2x-Z2 .b-m .b-m-l', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .bottom .b-l', { opacity: 0 }, { opacity: 1 }, 1],
                ['.d2x-Z2 .t-l-b', { opacity: 0 }, { opacity: 1 }, 1],
            ],
            triggerElement: `.${css.d2xZ2} .t-m-t-l`,
            triggerHook: 1,
            offset: '0%',
            duration: 700,
            asyncTimeLine: [0, 3, 3.5, 4, 4.5, 5, 5.5, 6.5, 7],
        });

        AniContainer.create({
            triggerElement: `.${css.d2xZ2} .t-m-t-l`,
            triggerHook: 1,
            offset: '0%',
            onEnter() {
                setIsEnter('enter');
            },
            onLeave() {
                setIsEnter('');
            },
        });
    }, []);

    return (
        <div className={`d2x-Z2 ${css.d2xZ2} GtmModuleData-section`} data-section-id={css.d2xZ2} data-section-title={'大容量 × 高出力 '}>
            <div className="z2-title">
                <p>大容量 × 高出力 </p>
                <p>快適も安心もクルマのなかに</p>
            </div>
            <div className="wrapper">
                <div className="sec2">
                    <div className="top">
                        <div className="t-l">
                            <div className="t-l-t box">
                                <EFPicture
                                    src="https://websiteoss.ecoflow.com/upload/image/1745404575303/Group%20212152-pc.jpg"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476146136/Group%20212152%20-h5.jpg"
                                />
                                <div className="text">
                                    充実の15出力ポート　
                                    <br />
                                    複数機器を
                                    <br />
                                    同時給電 & 充電
                                </div>
                            </div>
                            <div className="t-l-b box">
                                <EFPicture
                                    src="https://websiteoss.ecoflow.com/upload/image/1745476723329/Group%20212151-pc.jpg"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476723200/Group%20212151%20-h5.jpg"
                                />
                                <div className="text">
                                    排気ガス/騒音フリー & <br />
                                    簡単メンテナンス
                                </div>
                            </div>
                        </div>
                        <div className="t-m">
                            <div className="t-m-t">
                                <div className="t-m-t-l box">
                                    <EFPicture
                                        src="https://websiteoss.ecoflow.com/upload/image/1745476086106/Group%20211863-pc.jpg"
                                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476192211/Group%20211863%20-h5.jpg"
                                    />
                                    <div className="text">
                                        <div className="title">10年長寿命</div>
                                        <div className="desc">LFPバッテリー採用</div>
                                    </div>
                                </div>
                                <div className="t-m-t-r box">
                                    <EFPicture
                                        src="https://websiteoss.ecoflow.com/upload/image/1745476245883/Group%20211864-pc.jpg"
                                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476245782/Group%20211864%20-h5.jpg"
                                    />
                                    <div className="text">
                                        <div>高品質・BMS・堅牢設計</div>
                                    </div>
                                </div>
                            </div>
                            <div className="t-m-b box">
                                <EFPicture
                                    src="https://websiteoss.ecoflow.com/upload/image/1745476382918/Frame%20128720593-pc.jpg"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476391224/Frame%201612707427-h5.jpg"
                                />
                                <div className="text">
                                    <div className="title">
                                        <span className="bold">2000Wh</span>大容量
                                    </div>
                                    <div className="plus">+</div>
                                    <div className="desc">最大6kWhに容量拡張</div>
                                </div>
                            </div>
                        </div>
                        <div className="t-r box">
                            <EFPicture
                                src="https://websiteoss.ecoflow.com/upload/image/1745476458637/Frame%20128720590-pc.jpg"
                                srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476461207/Group%201612706690-h5.jpg"
                            />
                            <div className="text">シーンに合わせた 4つの急速充電</div>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="b-l box">
                            <EFPicture
                                src="https://websiteoss.ecoflow.com/upload/image/1745478540874/Frame%20128720596-pc.jpg"
                                srcMobile="https://websiteoss.ecoflow.com/upload/image/1745478540684/Frame%20128720596%20-h5.jpg"
                            />
                            <div className="text">
                                <div className="title">最大2400W</div>
                                <div className="desc">の家電を稼働可能</div>
                            </div>
                        </div>
                        <div className="b-m">
                            <div className="b-m-r box">
                                <EFPicture
                                    src="https://websiteoss.ecoflow.com/upload/image/1745476642343/02-9-bg%402x-pc.jpg"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476642155/02-9-bg%403x-h5.jpg"
                                />
                                <div className="text">
                                    スマホアプリで <br />
                                    誰でも簡単操作
                                </div>
                            </div>
                        </div>
                        <div className="b-m-r box last-box">
                            <EFPicture
                                src="https://websiteoss.ecoflow.com/upload/image/1745476580288/Group%20211878-pc.jpg"
                                srcMobile="https://websiteoss.ecoflow.com/upload/image/1745476580455/Frame%20211878-h5.jpg"
                            />
                            <div className="text">
                                <div className="title">{'<20ms自動電源'}</div>
                                <div className="desc">切り替え機能</div>
                            </div>
                        </div>
                    </div>
                    {locale === 'cn' && <p className="sec2-memo">{t('sec2_memo')}</p>}
                </div>
            </div>

            <H5 />
        </div>
    );
}
